// extracted by mini-css-extract-plugin
module.exports = {"mobile":"HighlightControls_mobile__r4gBc","desktop":"HighlightControls_desktop__ptAYY"};